module.exports = __webpack_public_path__ + "img/as-student.8ef3d0fc.svg";